import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Metabase extends Component {
    render() {
        return (
            <iframe
                src={this.props.iframeUrl}
                frameBorder="0"
                width="100%"
                height="100%"
                allowTransparency
                title="metabase"
            ></iframe>
        );
    }
}

Metabase.propTypes = {
    iframeUrl: PropTypes.string,
};

export default Metabase;
